"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const fastForwardButton_svg_1 = __importDefault(require("../../../../assets/icons/fastForwardButton.svg"));
const pauseButton_svg_1 = __importDefault(require("../../../../assets/icons/pauseButton.svg"));
const playButton_svg_1 = __importDefault(require("../../../../assets/icons/playButton.svg"));
const rewindButton_svg_1 = __importDefault(require("../../../../assets/icons/rewindButton.svg"));
const skipLeftButton_svg_1 = __importDefault(require("../../../../assets/icons/skipLeftButton.svg"));
const skipRightButton_svg_1 = __importDefault(require("../../../../assets/icons/skipRightButton.svg"));
const userStates_1 = require("../../../../types/userStates");
const mapParamsHandler_1 = require("../../../../utils/mapParamsHandler");
const S = __importStar(require("./TimelapseComponent.style"));
const NavigationButtons = ({ currentStep, totalSteps, onNextStep, onPreviousStep, onGoToStart, onGoToEnd, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [isPlaying, setIsPlaying] = (0, react_1.useState)(false);
    const { currentUserSettings } = (0, mapParamsHandler_1.useMapParams)();
    const isModalOpen = currentUserSettings === userStates_1.UserSettings.TimelapseView;
    // Auto-play functionality
    (0, react_1.useEffect)(() => {
        let intervalId;
        if (isPlaying) {
            intervalId = setInterval(() => {
                if (currentStep < totalSteps - 1) {
                    onNextStep();
                }
                else {
                    setIsPlaying(false);
                }
            }, 500);
        }
        return () => {
            if (intervalId)
                clearInterval(intervalId);
        };
    }, [isPlaying, currentStep, totalSteps, onNextStep]);
    (0, react_1.useEffect)(() => {
        if (isModalOpen) {
            setIsPlaying(true);
        }
    }, [isModalOpen]);
    const handlePlayPause = (0, react_1.useCallback)(() => {
        setIsPlaying((prev) => !prev);
    }, []);
    return (react_1.default.createElement(S.NavigationButtonsContainer, null,
        react_1.default.createElement(S.NavigationButton, { onClick: onGoToStart, disabled: currentStep === 0 },
            react_1.default.createElement("img", { src: rewindButton_svg_1.default, alt: t("timelapse.altRewind") })),
        react_1.default.createElement(S.NavigationButton, { onClick: onPreviousStep, disabled: currentStep === 0 },
            react_1.default.createElement("img", { src: skipLeftButton_svg_1.default, alt: t("timelapse.altSkipLeft") })),
        react_1.default.createElement(S.NavigationButton, { onClick: handlePlayPause },
            react_1.default.createElement("img", { src: isPlaying ? pauseButton_svg_1.default : playButton_svg_1.default, alt: t("timelapse.altPlay") })),
        react_1.default.createElement(S.NavigationButton, { onClick: onNextStep, disabled: currentStep === totalSteps - 1 },
            react_1.default.createElement("img", { src: skipRightButton_svg_1.default, alt: t("timelapse.altSkipRight") })),
        react_1.default.createElement(S.NavigationButton, { onClick: onGoToEnd, disabled: currentStep === totalSteps - 1 },
            react_1.default.createElement("img", { src: fastForwardButton_svg_1.default, alt: t("timelapse.altFastForward") }))));
};
exports.default = NavigationButtons;
